const newChat = {
    unSeenMsgCount: 0,
    chatCustSessionId: null,
    isChatTransfered: false,
    chatDetails: null,
    token: null,
    prevChat: [],
    currentChat: [],
    templateData: [],
    templateMsg: '',
    smartReply: {
        smartReplyOptions: [
            { name: "Yes sure!" },
            { name: "Sorry to hear that" },
            { name: "I will get back to you on this" }
        ],
        smartReplyCount: 0,
    },
    inputMessage: '',
    showChatDetails: false,
    isChatTemplateEnabled: false,
    showTempDetails: [],
    chatSearch: {
        searchKey: '',
        isSearchOpen: false
    }

}
const emailReply = {
    emailBody: null,
    replayMailEnabled: true,
    emailData: {
        custName: null,
        conversation: {
            from: [],
            to: [],
            cc: [],
            bcc: [],
            subject: null,
            data: null,
            send_at: null,
            file_ids: []
        }
    }
}
export function buildChatObject(data) {
    let prevChat = []
    if (data.previousChatHist) {
        prevChat = getPreviousChat(data.previousChatHist);
    }
    let newC = structuredClone(newChat);
    newC.chatCustSessionId = data.sessionId;
    newC.campaignName = data.campaignName || '';
    newC.prevChat = prevChat;
    newC.nonParsedCurrentChat = data.currentChatHist ? JSON.parse(data.currentChatHist) : []
    newC.currentChat = []
    newC.nonParsedCurrentChat.map((e => {
        try {
            let botHist = JSON.parse(e.msg)
            if (botHist.hasOwnProperty("CHAT_BOT_HISTORY")) {
                botHist["CHAT_BOT_HISTORY"].map((e1) => {
                    newC.currentChat.push(e1);
                });
            } else {
                newC.currentChat.push(e);
            }
        } catch (error) {
            newC.currentChat.push(e);
        }
    }))
    newC.chatDetails = (data.chatDetails ? (JSON.parse(data.chatDetails)) : data.token ? JSON.parse(data.token) : "") || (data.sessionDetails ? (JSON.parse(data.sessionDetails)) : "")
    if (newC.chatDetails?.channelType?.toLowerCase() === 'email') {
        newC.emailReply = JSON.parse(JSON.stringify(emailReply));
        newC.emailInfo = data;
        const rawConversation = data.conversation;
        newC.emailInfo.conversation = typeof rawConversation === 'string'
            ? JSON.parse(rawConversation)
            : (rawConversation || []);
    }
    newC.isFirstReply = "0"
    newC.token = data
    if (("" + newC.chatDetails.stateStartTime).length < 13) {
        newC.chatDetails.stateStartTime = Date.now() - (newC.chatDetails.stateStartTime * 1000);
    }
    // console.log("newC.chatDetails", newC)
    newC.dispositionType = data.dispositionType;
    newC.wrapUpTime = newC.dispositionType === "1" ? data && data.wrapupTime : -1;
    if (localStorage.getItem('answeredChatDetailsForChatInactivity') !== undefined && localStorage.getItem('answeredChatDetailsForChatInactivity') !== null) {
        let localStorageAnsweredChats = JSON.parse(localStorage.getItem('answeredChatDetailsForChatInactivity'))
        if (Object.keys(localStorageAnsweredChats).length > 0) {
            Object.keys(localStorageAnsweredChats).forEach((key) => {
                let data = localStorageAnsweredChats[key];
                if (newC.chatCustSessionId === key) {
                    newC.count = data.count;
                    delete localStorageAnsweredChats[key];
                }
            }
            )
            localStorage.setItem('answeredChatDetailsForChatInactivity', JSON.stringify(localStorageAnsweredChats));
            if (Object.keys(localStorageAnsweredChats).length <= 0) {
                localStorage.removeItem('answeredChatDetailsForChatInactivity')
            }
        }
    }
    return newC
}

export function getPreviousChat(previousChatHist) {
    let prevChat = JSON.parse(previousChatHist)
    if (prevChat) {
        prevChat.forEach((e) => {
            if (!e.transcript == '') {
                let temp = JSON.parse(e.transcript)
                e.transcript = temp
            }
        })
    }
    let groupedPrevChat = prevChat.reduce((result, chat) => {
        // removing empty chats from transcript and grouping on chat date
        if (!result[chat.StartDate] && !result[chat.transcript == []]) {
            result[chat.StartDate] = [];
        }
        if (chat.transcript && chat.transcript.length > 0) {
            result[chat.StartDate].push(chat);
        }
        return result;
    }, {});

    Object.keys(groupedPrevChat).forEach(chat => {
        let temp = []
        groupedPrevChat[chat].forEach((e) => {
            e.messages = e.transcript
            if (e.messages.length > 0) {
                e.messages.forEach((msg) => {
                    try {
                        let botHist = JSON.parse(msg.msg)
                        if (botHist.hasOwnProperty("CHAT_BOT_HISTORY")) {
                            botHist["CHAT_BOT_HISTORY"].map((e1) => {
                                temp.push(e1);
                            });
                        } else {
                            temp.push(msg)
                        }
                    } catch (error) {
                        temp.push(msg)
                    }
                })
            }
            delete e.transcript
            delete e.StartDate
            delete e.SNO
        })
        groupedPrevChat[chat] = temp;
        temp = []
    });

    return groupedPrevChat;
}



export function buildIncomingMessage(msgDetails) {
    if (msgDetails && msgDetails.type === "custLocation") {
        return {
            agent: "false",
            ts: msgDetails.timestamp,
            msg: (typeof msgDetails.coordinates === 'string') ? JSON.parse(msgDetails.coordinates) : msgDetails.coordinates,
            type: msgDetails.type,
            fname:msgDetails?.fname??''
        }
    }
    if (msgDetails && (msgDetails?.mediaType?.includes("image") || msgDetails?.mediaType?.includes("video"))) {
        return {
            agent: "false",
            ts: msgDetails.timestamp,
            msg: msgDetails.chatmsg ? msgDetails.chatmsg : msgDetails.url ? msgDetails.url : null,
            text: msgDetails.msg ? msgDetails.msg : null,
            type: msgDetails.type === 'inchatmulti' ? "text" : msgDetails.mediaType ? msgDetails.mediaType : msgDetails.type,
            fname: msgDetails?.fname ?? ''
        }
    }
    return {
        agent: "false",
        ts: msgDetails.timestamp,
        msg: msgDetails.chatmsg ? msgDetails.chatmsg : msgDetails.url ? msgDetails.url : null,
        type: msgDetails.type === 'inchatmulti' ? "text" : msgDetails.mediaType ? msgDetails.mediaType : msgDetails.type,
        fname: msgDetails?.fname ?? ''
    }
}

export function buildResponseMessage(msgDetails) {
    return {
        agent: "true",
        ts: (String)(Date.now()),
        msg: msgDetails.agentMsg,
        type: msgDetails.type,
        agentId: msgDetails.agentId,
        fname: msgDetails?.agentMsg?.split("/").pop()?? '',
        text: msgDetails.text || ''
    }
}
export function getUnseenMsgCount(chatSessionId, chatDetails, activeSessionId) {
    if (chatSessionId === activeSessionId) {
        return 0;
    }
    else {
        return chatDetails.unSeenMsgCount += 1
    }
}